import { createStore } from 'zustand/vanilla';
import { devtools } from 'zustand/middleware';

// Wishlist v2 CRC codes are not yet available in the published crc-code package.
// Keep this local mapping until the package exposes lib/buy/wishlists/v2/crcCodes.
var wishlistV2CrcCodes = {
  ITEM_LIMIT_EXCEEDED: '12F7F528',
  NOT_UNIQUE: '4D990978',
  PRODUCT_ALREADY_ADDED: 'BD29FA58',
  LIST_LIMIT_EXCEEDED: '7A4CF554',
  PRODUCT_NOT_SUPPORTED: 'B5739FE9'
};
var createErrorModalStore = function createErrorModalStore() {
  return createStore(devtools(function (set) {
    return {
      error: null,
      setError: function setError(error) {
        var _error$errors;
        var flattenedError = ((_error$errors = error.errors) === null || _error$errors === void 0 ? void 0 : _error$errors[0]) || error;
        flattenedError.crcCode = (flattenedError === null || flattenedError === void 0 ? void 0 : flattenedError.crcCode) || wishlistV2CrcCodes[flattenedError === null || flattenedError === void 0 ? void 0 : flattenedError.code];
        set({
          error: flattenedError
        });
      },
      clearError: function clearError() {
        return set({
          error: null
        });
      }
    };
  }, {
    name: 'NikeShop - ErrorModal',
    enabled: process.env.NODE_ENV === 'development'
  }));
};
export default createErrorModalStore;